// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
export var TvInteriorIdCacheMode;
(function (TvInteriorIdCacheMode) {
    TvInteriorIdCacheMode[TvInteriorIdCacheMode["TvChart"] = 0] = "TvChart";
    TvInteriorIdCacheMode[TvInteriorIdCacheMode["TvTradingPlatform"] = 1] = "TvTradingPlatform";
})(TvInteriorIdCacheMode || (TvInteriorIdCacheMode = {}));
class _TvInteriorIdCache {
    constructor() {
        this._mode = TvInteriorIdCacheMode.TvChart;
        this.tradableIdCache = new Map();
    }
    getInteriorId(ticker) {
        if (this.isTvChartMode())
            return ticker;
        let tikerWithoutRoute = InstrumentUtils.ParseRouteName(ticker);
        if (this.tradableIdCache.has(tikerWithoutRoute)) {
            return this.tradableIdCache.get(tikerWithoutRoute);
        }
        tikerWithoutRoute = InstrumentUtils.RemoveRouteName(ticker);
        if (this.tradableIdCache.has(tikerWithoutRoute)) {
            return this.tradableIdCache.get(tikerWithoutRoute);
        }
        return ticker;
    }
    saveInteriorId(fullName, interiorId) {
        if (this.isTvChartMode())
            return;
        this.tradableIdCache.set(fullName, interiorId);
    }
    get mode() {
        return this._mode;
    }
    set mode(value) {
        this._mode = value;
    }
    isTvChartMode() {
        return this._mode === TvInteriorIdCacheMode.TvChart;
    }
    isTvTradingPlatformMode() {
        return this._mode === TvInteriorIdCacheMode.TvTradingPlatform;
    }
}
export const TvInteriorIdCache = new _TvInteriorIdCache();
